import { v4 as uuid } from "uuid";

export const getHeaders = ()=>{

    return(["ID", "Name", "Revenue", "Hours", "Branch"])
    
}

export const getList = ()=>{
    return([
        {
            id: uuid(),
            name: "Kevin Sampong",
            revenue: 2300,
            hours: 102,
            branch: "Achimota"
        },
        {
            id: uuid(),
            name: "Adu Aliyah",
            revenue: 1200,
            hours: 80,
            branch: "Nungua"
        },
    ])
}